/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrototypeFirmwareUpdateModel
 */
export interface PrototypeFirmwareUpdateModel {
    /**
     * 
     * @type {string}
     * @memberof PrototypeFirmwareUpdateModel
     */
    firmware_id: string;
    /**
     * 
     * @type {string}
     * @memberof PrototypeFirmwareUpdateModel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PrototypeFirmwareUpdateModel
     */
    version: string;
    /**
     * 
     * @type {string}
     * @memberof PrototypeFirmwareUpdateModel
     */
    description: string;
}

/**
 * Check if a given object implements the PrototypeFirmwareUpdateModel interface.
 */
export function instanceOfPrototypeFirmwareUpdateModel(value: object): value is PrototypeFirmwareUpdateModel {
    if (!('firmware_id' in value) || value['firmware_id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function PrototypeFirmwareUpdateModelFromJSON(json: any): PrototypeFirmwareUpdateModel {
    return PrototypeFirmwareUpdateModelFromJSONTyped(json, false);
}

export function PrototypeFirmwareUpdateModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrototypeFirmwareUpdateModel {
    if (json == null) {
        return json;
    }
    return {
        
        'firmware_id': json['firmware_id'],
        'name': json['name'],
        'version': json['version'],
        'description': json['description'],
    };
}

export function PrototypeFirmwareUpdateModelToJSON(json: any): PrototypeFirmwareUpdateModel {
    return PrototypeFirmwareUpdateModelToJSONTyped(json, false);
}

export function PrototypeFirmwareUpdateModelToJSONTyped(value?: PrototypeFirmwareUpdateModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firmware_id': value['firmware_id'],
        'name': value['name'],
        'version': value['version'],
        'description': value['description'],
    };
}

